import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ModalCloseButtonComponent } from '../modal-close-button/modal-close-button.component';

@Component({
  selector: 'app-information-modal',
  templateUrl: './information-modal.component.html',
  styleUrls: ['./information-modal.component.scss'],
  imports: [
    MatDialogModule,
    MatIconModule,
    CommonModule,
    ModalCloseButtonComponent,
  ],
})
export class InformationModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string },
    private dialogRef: MatDialogRef<InformationModalComponent>
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
